import React, { useEffect, useState } from 'react';
import SupplierPageLayout from '../../components/SupplierPageLayout';
import SupplierStatusBadge from '../../components/SupplierStatusBadge';
import SupplierEmptyState from '../../components/SupplierEmptyState';
import { getLinkedRestaurants } from '../../services/supplierApi';

interface LinkedRestaurant {
  linkId: number;
  restroId: number;
  restaurantName: string;
  connectionStatus?: string;
  connectionLabel?: string;
  connectedOn?: string;
  active?: boolean;
}

const formatDate = (value?: string) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

const ConnectedRestaurants: React.FC = () => {
  const [restaurants, setRestaurants] = useState<LinkedRestaurant[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLinkedRestaurants()
      .then((data) => setRestaurants(data.restaurants ?? []))
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SupplierPageLayout
      wide
      title="Connected Restaurants"
      subtitle="Restaurants that have added you as a supplier and can send purchase orders."
      icon="fa-building-o"
      breadcrumbs={[
        { label: 'Dashboard', to: '/supplier/dashboard' },
        { label: 'Restaurants' },
      ]}
    >
      {error && <div className="sp-alert sp-alert--error">{error}</div>}
      {loading ? (
        <div className="sp-loading">Loading restaurants…</div>
      ) : restaurants.length === 0 ? (
        <SupplierEmptyState
          icon="fa-building-o"
          title="No restaurant links yet"
          message="When a restaurant adds you as a supplier, they will appear here."
        />
      ) : (
        <div className="sp-table-wrap">
          <table className="sp-table">
            <thead>
              <tr>
                <th>Restaurant</th>
                <th>Connected since</th>
                <th>Connection</th>
              </tr>
            </thead>
            <tbody>
              {restaurants.map((r) => (
                <tr key={r.linkId}>
                  <td>{r.restaurantName}</td>
                  <td>{formatDate(r.connectedOn)}</td>
                  <td>
                    {r.connectionStatus ? (
                      <SupplierStatusBadge
                        status={r.connectionStatus}
                        label={r.connectionLabel}
                      />
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SupplierPageLayout>
  );
};

export default ConnectedRestaurants;
